module.exports = __webpack_public_path__ + "static/media/success.a518fd0a.svg";